export default __webpack_public_path__ + "static/media/extension.d5d1eeea.svg";